var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',_vm._g(_vm._b({staticClass:"text-center font-weight-bold",class:{'d-block': _vm.block},attrs:{"color":_vm.statusObject.color,"label":"","small":"","dark":_vm.statusObject.darkMode}},'v-chip',_vm.$attrs,false),_vm.$listeners),[_vm._v("\n  "+_vm._s(_vm.statusObject.text)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }